import React, { FunctionComponent, useState } from 'react';
import './InlineMessage.scss';

// Currently, this is only use for Upstart offer error message, expand new types for more use cases if needed
type InlineMessageType = 'error';

interface InlineMessageProps {
  message: string;
  type: InlineMessageType;
}

const InlineMessage: FunctionComponent<InlineMessageProps> = ({
  message,
  type,
}) => {
  const [isDisplay, setIsDisplay] = useState(true);

  let displayIcon;
  let className = 'message-container';

  if (type === 'error') {
    displayIcon = (
      <i className="glyphicon glyphicon-exclamation-sign display-icon" />
    );
    className += ' error-message';
  }

  if (!isDisplay) {
    return null;
  }

  return (
    <div className={className}>
      {displayIcon}
      <div className="flex-1">{message}</div>
      <i
        className="glyphicon glyphicon-remove close-icon"
        onClick={() => setIsDisplay(false)}
      />
    </div>
  );
};

export default InlineMessage;
